import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Component({
	selector: 'user-photo',
	templateUrl: './user-photo.component.html',
	styleUrls: ['./user-photo.component.scss']
})
export class UserPhotoComponent implements OnChanges {

	@Input()
	sizeInRem: string;
	@Input()
	photo: string | null | undefined;

	constructor() {}

	// Gestiona los estilos de forma reactiva
	private styleSubject = new BehaviorSubject<Object>({});
	userPhotoStyle$: Observable<Object> = this.styleSubject.asObservable();

	ngOnChanges( changes: SimpleChanges ): void {
		// Cada vez que @Input() cambia
		const size: string = this.sizeInRem ? `${this.sizeInRem}rem` : '100%';
		const imageUrl: string | null = this.photo ? `url(${this.photo})` : null;

		const newStyle = {
			'background-image': imageUrl,
			height: size,
			width: size
		};

		// Emite el nuevo valor del estilo
		this.styleSubject.next( newStyle );
	}

}
